import { FormMode } from '../../controls/common/form-mode';
import { ParametersValuesFormContext } from '../parameters/parameters-values-form/parameters-values-form-context';
import { UserFormContext } from './user-form-context';

export class UserDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.userContext.mode = value;
        this.paramsContext.formMode = value;
    }

    public editedUserId: string = null;

    public paramsContext: ParametersValuesFormContext = new ParametersValuesFormContext();

    public userContext: UserFormContext = new UserFormContext();
}
